export default __webpack_public_path__ + "static/media/fw-amelia-er-White Gold.99d81dad.mp4";